import React, { useState } from 'react';
import Select, { components as selectComponents } from 'react-select';
import { useSelector } from 'react-redux';
import { MultipleValuesContainer as MultiValue } from './MultiValueComponent';
import './styles/AutoSuggestSelect.scss';
import { selectStyles } from './selectStyles';

const AutoSuggestionSelectComponent = (props) => {
  const themeColors = useSelector((state) => state.theme.themeValuesObject);
  const { inputClassName, components, fieldTouch, onFocus, ...otherProps } =
    props;
  const [selectClassName, setSelectClassName] = useState('');
  const customStyles = selectStyles({ themeColors });

  const Input = (props) => <selectComponents.Input {...props} maxLength={50} />;
  const defaultComponents = { MultiValue, Input, MultiValueRemove: () => null };
  return (
    <Select
      {...otherProps}
      styles={props.styles ? props.styles : customStyles}
      className={`generic-select ${inputClassName || ''} ${selectClassName}`}
      onFocus={() =>
        onFocus ? onFocus() : setSelectClassName('select-focus-border-admin')
      }
      onBlur={() => {
        setSelectClassName('');
        fieldTouch && fieldTouch(otherProps.name);
      }}
      components={
        components ? { ...defaultComponents, ...components } : defaultComponents
      }
      isClearable={false}
      hideSelectedOptions={false}
      classNamePrefix={'generic-select-prefix'}
      isMenuOpen={true}
    />
  );
};

export default AutoSuggestionSelectComponent;
